import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CalcOnlyAviaPackageRequest,
  CalcOnlyAviaPackageResponse,
  SearchOnlyAviaPackagesRequest,
  SearchOnlyAviaPackagesResponse
} from '@appTypes/api.types';
import { GetBestOffersResponse, GetRecentSearchesResponse } from '@appTypes/redefined-types';
import { environment } from '@env/environment';

@Injectable()
export class AviaApiService {
  readonly #httpClient = inject(HttpClient);

  readonly #apiEndPoint: string = environment.urls.api + '/OnlyAviaPackages/';
  readonly #mockupsApiEndPoint: string = 'assets/_api_mockups_/Flights/';

  getRecentSearches() {
    return this.#httpClient.get<GetRecentSearchesResponse>(this.#mockupsApiEndPoint + 'GetRecentSearchs.json');
  }

  getBestOffers() {
    return this.#httpClient.get<GetBestOffersResponse>(this.#mockupsApiEndPoint + 'GetBestOffers.json');
  }

  searchOnlyAviaPackages(payload: SearchOnlyAviaPackagesRequest) {
    return this.#httpClient.post<SearchOnlyAviaPackagesResponse>(this.#apiEndPoint + 'SearchOnlyAviaPackages', payload);
  }

  calcPackage(payload?: CalcOnlyAviaPackageRequest) {
    return this.#httpClient.post<CalcOnlyAviaPackageResponse>(this.#apiEndPoint + 'CalcPackage', {
      ...payload
    });
  }
}
